import type { HistorySubjectOf } from "./types";

// The server sends an entry's scope as two ids, at most one of them set; null is a project-wide entry.
export const historySubjectOf: HistorySubjectOf = ({
  floorPlanId,
  diagramId,
}) => {
  if (floorPlanId !== null) return { kind: "plan", floorPlanId };
  if (diagramId !== null) return { kind: "diagram", diagramId };
  return null;
};
